<div class="grid">
  <div class="col">
    <div class="field mb-1">
      <label class="font-medium required-field">Дата начала</label>
      <crm-datepicker
        [(value)]="startAt"
        [showTime]="true"
        [stepMinute]="15"
        (valueChange)="changeDateStartAt()"
        [disabled]="isDisabledStart"
        [inputStyleClass]="errors?.startAt ? 'ng-invalid ng-dirty' : ''"
        [appendTo]="appendTo"></crm-datepicker>
      <small
        *ngIf="errors?.startAt"
        class="p-error">
        {{ errors.startAt | join }}
      </small>
    </div>
  </div>
  <div class="col">
    <div class="field mb-1">
      <label class="font-medium required-field">Время окончания</label>
      <crm-datepicker
        [(value)]="endAt"
        (valueChange)="changeDateEndAt()"
        [disabled]="!startAt || isDisabledEnd"
        [timeOnly]="true"
        [stepMinute]="15"
        [inputStyleClass]="errors?.endAt ? 'ng-invalid ng-dirty' : ''"
        [appendTo]="appendTo">
      </crm-datepicker>
      <small
        *ngIf="errors?.endAt"
        class="p-error">
        {{ errors.endAt | join }}
      </small>
    </div>
  </div>
</div>
